import { createOption } from './createOption';
import Radio from './Radio';
import Checkbox from './Checkbox';
import { SingleOptionProps, MultiOptionProps } from './types';

export const SingleOption = createOption<SingleOptionProps>(Radio);
export const MultiOption = createOption<MultiOptionProps>(Checkbox);
